import React, { useState } from 'react';
import { Modal } from './Modal';
import '../styles/RegistrationForm.css';

interface FormData {
  firstname: string;
  lastname: string;
  phone: string;
  dob: string;
  gender: string;
  email: string;
  address: string;
}

export const RegistrationForm: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    firstname: '',
    lastname: '',
    phone: '',
    dob: '',
    gender: '',
    email: '',
    address: ''
  });
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!termsAccepted) {
      alert('Vui lòng đồng ý với điều khoản sử dụng và chính sách bảo mật');
      return;
    }
    setModalContent('success');
    setShowModal(true);
    setFormData({
      firstname: '',
      lastname: '',
      phone: '',
      dob: '',
      gender: '',
      email: '',
      address: ''
    });
    setTermsAccepted(false);
  };

  const openTermsModal = (type: 'terms' | 'privacy') => {
    setModalContent(type);
    setShowModal(true);
  };

  return (
    <div className="registration-container">
      <div className="registration-banner-image">
        <img src="/images/logo-top.png" width="100%" alt="Membership Banner" />
      </div>
      <h1 className="registration-title">Đăng ký thành viên</h1>
      <form className="registration-form" onSubmit={handleSubmit} autoComplete="off">
        <div className="form-field">
          <input
            type="text"
            id="firstname"
            name="firstname"
            required
            placeholder=" "
            value={formData.firstname}
            onChange={handleInputChange}
          />
          <label htmlFor="firstname">Họ</label>
        </div>
        <div className="form-field">
          <input
            type="text"
            id="lastname"
            name="lastname"
            required
            placeholder=" "
            value={formData.lastname}
            onChange={handleInputChange}
          />
          <label htmlFor="lastname">Tên</label>
        </div>
        <div className="form-field">
          <input
            type="tel"
            id="phone"
            name="phone"
            required
            pattern="[0-9]{10,15}"
            placeholder=" "
            value={formData.phone}
            onChange={handleInputChange}
          />
          <label htmlFor="phone">Số điện thoại</label>
        </div>
        <div className="form-field">
          <input
            type="date"
            id="dob"
            name="dob"
            placeholder="dd/mm/yyyy"
            value={formData.dob}
            onChange={handleInputChange}
          />
          <label htmlFor="dob">Ngày sinh</label>
        </div>
        <div className="form-field">
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
          >
            <option value="" disabled></option>
            <option value="male">Nam</option>
            <option value="female">Nữ</option>
            <option value="other">Khác</option>
          </select>
          <label htmlFor="gender">Giới tính</label>
        </div>
        <div className="form-field">
          <input
            type="email"
            id="email"
            name="email"
            placeholder=" "
            value={formData.email}
            onChange={handleInputChange}
          />
          <label htmlFor="email">Email</label>
        </div>
        <div className="form-field">
          <input
            type="text"
            id="address"
            name="address"
            placeholder=" "
            value={formData.address}
            onChange={handleInputChange}
          />
          <label htmlFor="address">Địa chỉ</label>
        </div>
        <div className="form-field terms-checkbox">
          <input
            type="checkbox"
            id="terms-checkbox"
            required
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
          />
          <span>
            Tôi đồng ý với{' '}
            <a href="#" className="terms-link" onClick={() => openTermsModal('terms')}>
              điều khoản sử dụng
            </a>{' '}
            và{' '}
            <a href="#" className="terms-link" onClick={() => openTermsModal('privacy')}>
              chính sách bảo mật
            </a>
          </span>
        </div>
        <button type="submit" disabled={!termsAccepted}>
          Đăng ký
        </button>
      </form>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        content={modalContent}
      />
    </div>
  );
}; 